import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getOrganisationSetting,addOrganisationSetting,updateOrganisation, getOrganizatioanApi } from "api";
import { withTranslation } from "react-i18next";

class GstRate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      data:null
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }
  componentDidMount() {
    getOrganizatioanApi().then(response => {
      this.setState({data:response.data.organizations[0]})
    }).catch(err => {
      console.log(err)
    })
  }
  async handleSubmit(e, values) {
    e.preventDefault();
   const data = await updateOrganisation(values.id,values)
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "Manage organization";
    const { validation } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t('P3Y Diamond Organization Settings')} />
            <Row>
              <Col xl="12">
                <Formik
                  enableReinitialize={true}
                  initialValues={this.state.data}
                  validationSchema={Yup.object().shape({
                    attachment: Yup.mixed()
                      .nullable()
                      .notRequired()
                      .test(
                        "FILE_SIZE",
                        "Uploaded file is too big.",
                        value => !value || (value && value.size <= FILE_SIZE)
                      )
                      .test(
                        "FILE_FORMAT",
                        "Uploaded file has unsupported format.",
                        value =>
                          !value ||
                          (value && SUPPORTED_FORMATS.includes(value.type))
                      ),
                    gstRate: Yup.number().min(0).max(99).required("This Value is required"),
                    cgstRate: Yup.number().min(0).max(99999).required("This Value is required"),
                    sgstRate: Yup.number().min(0).max(99999).required("This Value is required"),
                    cvdRate: Yup.number().min(1).max(99999).required("Please Enter CVD Rate"),
                    lphtRate: Yup.number().min(1).max(99999).required("Please Enter LPHT rate"),
                    realRate: Yup.number().min(1).max(99999).required("Please Enter REAL rate"),
                    jiramRate: Yup.number().min(1).max(99999).required("Please Enter JIRAM rate"),
                    bankName: Yup.string().min(1).max(255).required("This Value is required"),
                    ifscCode: Yup.string().min(1).max(255).required("This Value is required"),
                    acNo: Yup.string().min(1).max(255).required("This Value is required"),
                    branchName: Yup.string().min(1).max(255).required("This Value is required"),
                    declaration: Yup.string().min(1).required(
                      "This Value is required"
                    ),
                    tac: Yup.string().min(1).required("This Value is required"),
                  })}
                  onSubmit={async (values) => {}}
                >

                  {({ errors, status, touched, values }) => (
                    <div className="">
                      <Form className="needs-validation">
                        <Row className="my-3 pb-4 rounded bg-white">
                          <h4 className="text-black fw-bold py-3">{this.props.t('GST Rate')}</h4>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="gstRate"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t('GST Rate')}
                              </h5>
                            </Label>
                            <div className="col-md-10">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.gstRate && touched.gstRate
                                    ? " is-invalid"
                                    : "")
                                }
                                type="number" onWheel={(e) => e.target.blur()}
                                name="gstRate"
                                placeholder="1.5%"
                              />
                              <ErrorMessage
                                name="gstRate"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="cgstRate"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t('CGST Rate')}
                              </h5>
                            </Label>
                            <div className="col-md-10">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.cgstRate && touched.cgstRate
                                    ? " is-invalid"
                                    : "")
                                }
                                type="number" onWheel={(e) => e.target.blur()}
                                name="cgstRate"
                                placeholder="0.75%"
                              />
                              <ErrorMessage
                                name="cgstRate"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="sgstRate"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t('SGST Rate')}
                              </h5>
                            </Label>
                            <div className="col-md-10">
                              <Field
                                className={
                                  "form-control fs-5 text-uppercase" +
                                  (errors.sgstRate && touched.sgstRate
                                    ? " is-invalid"
                                    : "")
                                }
                                type="number" onWheel={(e) => e.target.blur()}
                                name="sgstRate"
                                placeholder="0.75%"
                              />
                              <ErrorMessage
                                name="sgstRate"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                        </Row>
                        <Row className="my-3 pb-4 rounded bg-white">
                          <h4 className="text-black fw-bold py-3">
                            {this.props.t('Rate Of Work')}
                          </h4>
                          <div className="mb-3 row">
                            <div className="col-md-6 col-12">
                              <div className="row">
                                <div className="col-md-4">
                                  <Label
                                    htmlFor="cvdRate"
                                    className="col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("CVD Rate")}
                                    </h5>
                                  </Label>
                                </div>
                                <div className="col-md-8">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.cvdRate && touched.cvdRate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="number" onWheel={(e) => e.target.blur()}
                                    name="cvdRate"
                                    placeholder="Different Rate"
                                  />
                                  <ErrorMessage
                                    name="cvdRate"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-12">
                              <div className="row">
                                <div className="col-md-4 text-start text-lg-center">
                                  <Label
                                    htmlFor="lphtRate"
                                    className="col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("LPHT Rate")}
                                    </h5>
                                  </Label>
                                </div>
                                <div className="col-md-8">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.lphtRate && touched.lphtRate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="number" onWheel={(e) => e.target.blur()}
                                    name="lphtRate"
                                    placeholder="Different Rate"
                                  />
                                  <ErrorMessage
                                    name="lphtRate"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <div className="col-md-6 col-12">
                              <div className="row">
                                <div className="col-md-4">
                                  <Label
                                    htmlFor="realRate"
                                    className="col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("REAL Rate")}
                                    </h5>
                                  </Label>
                                </div>
                                <div className="col-md-8">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.realRate && touched.realRate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="number" onWheel={(e) => e.target.blur()}
                                    name="realRate"
                                    placeholder="Different Rate"
                                  />
                                  <ErrorMessage
                                    name="realRate"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-12">
                              <div className="row">
                                <div className="col-md-4 text-start text-lg-center">
                                  <Label
                                    htmlFor="jiramRate"
                                    className="col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("JIRAM Rate")}
                                    </h5>
                                  </Label>
                                </div>
                                <div className="col-md-8">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.jiramRate && touched.jiramRate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="number" onWheel={(e) => e.target.blur()}
                                    name="jiramRate"
                                    placeholder="Different Rate"
                                  />
                                  <ErrorMessage
                                    name="jiramRate"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Row>
                        <Row className="my-3 pb-4 rounded bg-white">
                          <h4 className="text-black fw-bold py-3">
                            {this.props.t('Bank Details')}
                          </h4>
                          <div className="mb-3 row">
                            <div className="col-md-6 col-12">
                              <div className="row">
                                <div className="col-md-4">
                                  <Label
                                    htmlFor="bankName"
                                    className="col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t('Bank Name')}
                                    </h5>
                                  </Label>
                                </div>
                                <div className="col-md-8">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.bankName && touched.bankName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="text"
                                    name="bankName"
                                    placeholder="Federal Bank"
                                  />
                                  <ErrorMessage
                                    name="bankName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-12">
                              <div className="row">
                                <div className="col-md-4 text-start text-lg-center">
                                  <Label
                                    htmlFor="ifscCode"
                                    className="col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t('IFSC Code')}
                                    </h5>
                                  </Label>
                                </div>
                                <div className="col-md-8">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.ifscCode && touched.ifscCode
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="text"
                                    name="ifscCode"
                                    placeholder="FDRL0001865"
                                  />
                                  <ErrorMessage
                                    name="ifscCode"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <div className="col-md-6 col-12">
                              <div className="row">
                                <div className="col-md-4">
                                  <Label
                                    htmlFor="acNo"
                                    className="col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("A/C No")}
                                    </h5>
                                  </Label>
                                </div>
                                <div className="col-md-8">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.acNo && touched.acNo
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="text"
                                    name="acNo"
                                    placeholder="18650200020693"
                                  />
                                  <ErrorMessage
                                    name="acNo"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-12">
                              <div className="row">
                                <div className="col-md-4 text-start text-lg-center">
                                  <Label
                                    htmlFor="branchName"
                                    className="col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("Branch Name")}
                                    </h5>
                                  </Label>
                                </div>
                                <div className="col-md-8">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.branchName && touched.branchName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="text"
                                    name="branchName"
                                    placeholder="Branch Name"
                                  />
                                  <ErrorMessage
                                    name="branchName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Row>
                        <Row className="my-3 py-4 rounded bg-white">
                          <div className="mb-3 row">
                            <Label
                              htmlFor="declaration"
                              className="col-md-2 col-form-label"
                            >
                              <h4 className="text-black fw-bold">
                              {this.props.t("Declaration")}
                              </h4>
                            </Label>
                            <div className="col-md-10">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.declaration && touched.declaration
                                    ? " is-invalid"
                                    : "")
                                }
                                type="text"
                                name="declaration"
                                as="textarea"
                                rows="5"
                              />
                              <ErrorMessage
                                name="declaration"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="tac"
                              className="col-md-2 col-form-label"
                            >
                              <h4 className="text-black fw-bold">
                                
                                {this.props.t("Terms and Conditions")}
                              </h4>
                            </Label>
                            <div className="col-md-10">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.tac && touched.tac
                                    ? " is-invalid"
                                    : "")
                                }
                                type="text"
                                name="tac"
                                as="textarea"
                                rows="5"
                              />
                              <ErrorMessage
                                name="tac"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                        </Row>

                        <Row className="my-3 py-4">
                          <div className="col-md-12 mb-5 text-end">
                            <input
                              type="submit"
                              value="Submit"
                              className="btn btn-primary w-xl fs-5"
                              onClick={() => this.handleSubmit(event, values)}
                            />
                          </div>
                        </Row>
                      </Form>
                    </div>
                  )}
                </Formik>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(GstRate);
